import { render, staticRenderFns } from "./JcReturnBook.vue?vue&type=template&id=3e72a3f8&scoped=true"
import script from "./JcReturnBook.vue?vue&type=script&lang=js"
export * from "./JcReturnBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e72a3f8",
  null
  
)

export default component.exports